import { Orientation } from '../_components/flow-builder/canvas-element/Orientation';
import { BaseFlowConfig } from '../_components/flow-builder/TypeDefs';

export const colors = {
  primary: '#6EDFF6', // '#fd5f4b',
  secondary: '#C79FF9', // '#575BD4',
  tertiary: '#040F82', // '#57C5A8',
  black: '#2D2D2D',
  white: '#FFFFFF',
  connector: '#2D2D2D',
  conditionText: '#fd604b',
  connectorExpression: '#D4643A',
};

export const DEFAULT_CONFIG: BaseFlowConfig = {
  itemHeight: 80,
  itemWidth: 120,
  itemConnectorInRadius: 5,
  itemConnectorOutRadius: 5,
  itemStrokeWidth: 2,
  itemPadding: 15,
  connectorStrokeWidth: 2,
  connectorClickRadius: 5,
  startBtnHeight: 40,
  startBtnWidth: 100,
  itemBtnGroupRadius: 8,
  startBtnText: 'Start',
  itemFillColor: '#F4F4F4',
  itemSelectedFillColor: '#F4F4F4',
  itemStrokeColor: '#2B9348',
  itemSelectedStrokeColor: '#7957E7',
  itemInConnectorColor: colors.black,
  itemSelectedInConnectorColor: colors.black,
  itemOutConnectorColor: colors.black,
  itemSelectedOutConnectorColor: colors.black,
  itemNameColor: colors.black,
  itemSelectedNameColor: colors.black,
  itemDescriptionColor: colors.black,
  itemSelectedDescriptionColor: colors.black,
  itemErrorColor: 'red',
  startBtnFillColor: colors.tertiary,
  startBtnTextColor: colors.white,
  startBtnSelectionColor: '#2B9348',
  itemConditionTextBgColor: colors.conditionText,
  itemConditionTextFgColor: colors.white,

  connectorStrokeColor: colors.connector,
  connectorParallelStrokeColor: colors.connector,
  connectorSelectedStrokeColor: colors.tertiary,
  connectorArrowColor: colors.tertiary,
  connectorFillColor: colors.black,
  connectorSelectedFillColor: colors.black,
  itemBtnGroupBackgroundColor: '#7957E7',

  fontFamily: 'Roboto',
  itemNameFontSize: 16,
  itemVersionFontSize: 14,
  itemDescriptionFontSize: 12,
  itemConditionTextFontSize: 18,
  connectorTextFontSize: 14,
  lineHeightRatio: 1.4,

  orientation: Orientation.HORIZONTAL,
  canvasBackgroundColor: '#F1F1F1',
  itemConnectorOutlined: false,
  draggable: true,

  stepCardHeight: 160,
  stepCardWidth: 360,
  initiateStepCardFillColor: colors.white,
  initiateStepCardTextColor: colors.black
};
// Adding separately as its giving error while passing as string
export const contextId = '2d';

export const flowBuilderConstants = {
  zoomWheelDelta: 5000,
  minZoomValue: 0.4,
  maxZoomValue: 1.2,
  zoomDiffValue: 0.05,
  zoomLevelDefault: 0.8,
  clickMaxDuration: 500,
  clickMaxMousemove: 5,
  translateXDefault: 0,
  translateYDefault: 0,
  elementCornerRadius: 6,
  elementDescriptionMargin: 16,
  elementVersionMargin: 0,
  startBtnPosition: { x: 30, y: 50 },
  compensatoryDummyCardOffset: 10,
  conditionTextBoxOffset: {
    x: 130,
    y: 18
  },
  conditionTextBoxSize: {
    h: 36,
    w: 100
  },
  defaultCursor: 'default',
  initiateStepCardPosition: { x: 30, y: 50 },
  stepCardRadius: 20,
};

export const addPayloadTransformationText = 'Set up payload via menu click.';
